import { Button } from "components/Button/Button";
import { Input, Select } from "components/Form";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import ReactDatePicker from "react-datepicker";
import { getVastuDengiById, updateVastuDengi } from "services/vastudengi";
import { simpleDateFormat } from "utils";

export default function UpdateDengi() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState({});

  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  // ************************************** Fetch Records **********************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getVastuDengiById({
        id: id,
      });
      hideLoader();
      if (res.code === 200) {
        const {
          id,
          ProviderName,
          ProviderMobile,
          ItemName,
          Quantity,
          DateofGiving,
          ReceiverName,
          City,
          AddedOn,
        } = res.data.VastuDengiRecord;
        setData({
          ...data,
          fromName: ProviderName,
          toName: ReceiverName,
          mobile: ProviderMobile,
          city: City,
          quantity: Quantity,
          dengiItem: ItemName,
          date: DateofGiving,
        });
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, []);

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!data.fromName) {
      errorField["fromName"] = "कृपया देणगी देणाऱ्याचे नाव भरा";
      formIsValid = false;
    }
    if (!data.toName) {
      errorField["toName"] = "कृपया देणगी घेणाऱ्याचे नाव भरा";
      formIsValid = false;
    }
    if (!data.mobile) {
      errorField["mobile"] = "कृपया मोबाई नंबर भरा";
      formIsValid = false;
    } else if (data.mobile.length !== 10) {
      errorField["mobiles"] = "कृपया मोबाई नंबर दहा(१०) अंकी भरा ";
      formIsValid = false;
    }
    if (!data.city) {
      errorField["city"] = "कृपया शहर भरा";
      formIsValid = false;
    }
    if (!data.dengiItem) {
      errorField["dengiItem"] = "कृपया देणगीवस्तूचे नाव भरा";
      formIsValid = false;
    }
    if (!data.quantity) {
      errorField["quantity"] = "कृपया प्रमाण भरा";
      formIsValid = false;
    }
    if (!data.date) {
      errorField["date"] = "कृपया तारीख भरा";
      formIsValid = false;
    }

    setErrorField(errorField);
    return formIsValid;
  };
  //*********************Submit Form Handler********************************** *//
  const submitForm = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setSubmitLoading(true);
      try {
        const res = await updateVastuDengi({
          id: id,
          ProviderName: data.fromName,
          ProviderMobile: data.mobile,
          ItemName: data.dengiItem,
          Quantity: data.quantity,
          DateofGiving: simpleDateFormat(data.date),
          ReceiverName: data.toName,
          City: data.city,
        });
        if (res.code === 200) {
          toast.success(res.message);
          setSubmitLoading(false);
          navigate(-1);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap"></div>
              <h4 className="Title">
                {" "}
                <Link to={-1}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                नोंदनी दुरुस्त करा / माहिती दुरुस्त करा
              </h4>
            </div>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <form onSubmit={submitForm}>
                  <div className="form-group row mt-1">
                    <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="fromName"
                                value={data.fromName}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="देणगी देणाऱ्याचे नाव भरा"
                                className={`form-control `}
                                maxLength={50}
                                label="देणगी देणाऱ्याचे नाव"
                                error={errorField.fromName}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="toName"
                                value={data.toName}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="देणगी घेणाऱ्याचे नाव भरा"
                                className={`form-control `}
                                maxLength={50}
                                label="देणगी घेणाऱ्याचे नाव"
                                error={errorField.toName}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="mobile"
                                value={data.mobile}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value.replace(/\D/g, ""),
                                  });
                                }}
                                placeholder="मोबाईल नंबर भरा"
                                className={`form-control `}
                                maxLength={10}
                                label="मोबाईल"
                                error={errorField.mobile}
                                required
                              />
                              {errorField.mobiles && (
                                <span
                                  className="error"
                                  style={{
                                    color: "#dc3545",
                                    fontSize: "13px",
                                    marginLeft: "1px",
                                  }}
                                >
                                  {errorField.mobiles}
                                </span>
                              )}
                            </div>

                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="city"
                                value={data.city}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="शहर भरा"
                                className={`form-control `}
                                maxLength={20}
                                label="शहर"
                                error={errorField.city}
                                required
                              />
                            </div>

                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="dengiItem"
                                value={data.dengiItem}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="देणगीवस्तूचे नाव भरा"
                                className={`form-control `}
                                maxLength={10}
                                label="देणगीवस्तूचे नाव"
                                error={errorField.dengiItem}
                                required
                              />
                            </div>

                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="quantity"
                                value={data.quantity}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="Ex 10 kg or 10 unit"
                                className={`form-control `}
                                maxLength={20}
                                label="प्रमाण"
                                error={errorField.quantity}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <label className="my-1">
                                देणगी घेण्याची तारीख{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <br />
                              <ReactDatePicker
                                selected={data.date}
                                onChange={(e) => setData({ ...data, date: e })}
                                className={`form-control w350px ${
                                  !data.date && errorField.date && "is-invalid"
                                }`}
                                minDate={new Date()}
                                // maxDate={courseEndDate}
                                showIcon
                                dateFormat="dd-MMM-yyyy"
                                placeholderText="dd-MMM-yyyy"
                                showMonthDropdown
                                useShortMonthInDropdown
                                showYearDropdown
                                yearDropdownItemNumber={100}
                                scrollableYearDropdown
                                onChangeRaw={(e) => e.preventDefault()}
                                {...submitButtonElement}
                              />
                              <div
                                className={`invalid-feedback ${
                                  !data.date && errorField.date && "d-block"
                                }`}
                              >
                                {errorField.date}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <Button
                      to={-1}
                      // {...submitButtonElement}
                      style={{ marginRight: "5px" }}
                    >
                      रद्द करा
                    </Button>
                    <Button
                      type="submit"
                      // {...submitButtonElement}
                    >
                      {/* Add Customer */}
                      जमा करा
                    </Button>
                  </div>{" "}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
